import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';

export interface TabItem {
  value: string;
  label: string;
  icon?: string;
}

@Component({
  selector: 'app-tabs',
  template: `
    <div class="flex flex-col h-full" [class]="styleClass()">
      <div class="flex border-b border-gray-200 shrink-0" [attr.role]="'tablist'">
        @for (tab of tabs(); track tab.value) {
          <button
            type="button"
            [class]="tabClasses(tab)"
            (click)="selectTab(tab.value)"
            [attr.role]="'tab'"
            [attr.aria-selected]="activeTab() === tab.value"
            [attr.aria-controls]="'panel-' + tab.value"
            [attr.aria-label]="tab.label"
          >
            @if (tab.icon) {
              <i [class]="tab.icon + ' mr-1'" aria-hidden="true"></i>
            }
            {{ tab.label }}
          </button>
        }
      </div>
      <div class="flex-1 min-h-0 overflow-auto">
        <ng-content />
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class UiTabs {
  readonly tabs = input<TabItem[]>([]);
  readonly styleClass = input<string>('');

  readonly activeTab = model<string>('');
  readonly valueChange = output<string>();

  protected tabClasses(tab: TabItem): string {
    const base = 'px-4 py-2.5 text-sm font-medium border-b-2 transition-all duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-500/30';
    const selected = this.activeTab() === tab.value
      ? 'border-accent-600 text-accent-600'
      : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300';
    return `${base} ${selected}`;
  }

  selectTab(value: string): void {
    this.activeTab.set(value);
    this.valueChange.emit(value);
  }
}
